import fetch from '../../lib/wrappedFetch'
import config from '../../config'

class InspirationsService {
  searchInspirations = (params) => {
    return fetch(config.config.endpointUrls.searchInspirations(), {
      method: 'POST',
      body: params
    })
  }
  fetchInspirationById = (params) => {
    return fetch(config.config.endpointUrls.fetchInspirationById(params), {
      method: 'GET'
    })
  }
  deleteInspirationById = (params) => {
    return fetch(config.config.endpointUrls.deleteInspirationById(params), {
      method: 'DELETE'
    })
  }
  fetchAllInspirationTags = (params) => {
    return fetch(config.config.endpointUrls.fetchAllInspirationTags(params), {
      method: 'GET'
    })
  }
}

export default new InspirationsService()



// WEBPACK FOOTER //
// ../src/services/inspirationsService/inspirationsService.js